<div class="fixed inset-0 z-50 flex items-center justify-center bg-[var(--bg-fondo)]/80 backdrop-blur-sm">
  <div
    class="animate__animated animate__zoomIn bg-white rounded-lg bg-white rounded-2xl shadow-2xl p-8 transition-all duration-300 w-11/12 md:w-2/3 lg:w-1/3">
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-2xl font-bold">Selecciona tu ciudad</h2>
    </div>
    <p class="text-gray-600 mb-6">Para mostrarte la información de tu ciudad</p>

    @if (loading) {
    <div class="flex justify-center items-center h-32">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
    </div>
    } @else if (error) {
    <div class="text-center text-red-600 mb-4">
      {{ error }}
    </div>
    } @else {
    <div class="grid gap-4" [ngClass]="{
          'grid-cols-1': cities.length === 1,
          'grid-cols-2': cities.length > 1
        }">
      @for (city of cities; track city.id;let i = $index; let last = $last;) {
      <button (click)="selectCity(city)"
        class="p-4 border rounded-lg hover:bg-gray-50 transition-colors duration-200 flex flex-col items-center justify-center text-center"
        [ngClass]="{
              'col-span-2 justify-self-center w-1/2': cities.length % 2 === 1 && last && cities.length > 1
            }">
        <span class="font-semibold text-lg">{{ city.city }}</span>
        <span class="text-sm text-gray-500">{{ city.name }}</span>
      </button>
      }
    </div>
    }
  </div>
</div>